import React from "react";
import theme from "../configuration/theme";
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { ThemeProvider } from "@mui/material";
const ThemeProviderWrapper = ({ children }) => {
    return <ThemeProvider theme={theme}>
            <ScopedCssBaseline >
                {children}
            </ScopedCssBaseline>
        </ThemeProvider>
}

export default ThemeProviderWrapper;